import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
//import {HttpModule} from '@angular/http';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';

import { AuthenticatedGuard } from './authenticated.guard';
import { NewRegisterUserGuard } from './newRegisterUser.guard';
import { MfaLoginGuard } from './mfaLogin.guard';
import { AuthStateGuard } from './authState.guard';
import { JwtHelperService } from './services/jwt-helper.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { LoggingService } from './services/logging.service';
import { PopNotificationService } from './services/pop-notification.service';
import { WindowRefService } from './services/window-ref.service';
import { DashboardService } from './services/dashboard.service';

import { FormlyManipulation } from './helpers/generateFormlyData';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FormGroupContentComponent } from './components/form/form-group-content/form-group-content.component';
import { FormGroupTextboxComponent } from './components/form/form-group-textbox/form-group-textbox.component';
import { FormGroupFooterComponent } from './components/form/form-group-footer/form-group-footer.component';
import { PanelComponent } from './components/panel/panel.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { DefaultPageComponent } from './components/default-page/default-page.component';
import { MainComponent } from './components/main/main.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { IconStatusComponent } from './components/icon-status/icon-status.component';

import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { NavigationButtonComponent } from './components/navigation-button/navigation-button.component';

import { NotificationEffects } from './effects/notification.effect';
import { PortalInformationEffects } from './effects/portalInfo.effect';
import { ApplicationVersionEffects } from './effects/appVersion.effect';

import { InputMaskDirective } from './directives/input-mask.directive';
import { ErrorContainerComponent } from './containers/error-container/error-container.component';
import { DashboardContainerComponent } from './containers/dashboard-container/dashboard-container.component';
import { PortalInfoService } from './services/portalInfo.service';
import { BlockTemplateComponent } from './components/block-template/block-template.component';
import { VersionCheckerService } from './services/version-checker.service';

@NgModule({
  imports: [
    FormsModule, ReactiveFormsModule,
    CommonModule, RouterModule,
    EffectsModule.run(NotificationEffects),
    EffectsModule.run(PortalInformationEffects),
    EffectsModule.run(ApplicationVersionEffects)
  ],
  declarations: [
    NotFoundComponent,
    SpinnerComponent,
    FormGroupContentComponent,
    FormGroupTextboxComponent,
    FormGroupFooterComponent,
    PanelComponent,
    NavbarComponent,
    FooterComponent,
    DefaultPageComponent,
    MainComponent,
    SidebarComponent,
    IconStatusComponent,
    SafeHtmlPipe,
    EllipsisPipe,
    NavigationButtonComponent,
    InputMaskDirective,
    ErrorContainerComponent,
    DashboardContainerComponent,
    BlockTemplateComponent
  ],
  exports: [
    NotFoundComponent,
    SpinnerComponent,
    FormGroupContentComponent,
    FormGroupTextboxComponent,
    FormGroupFooterComponent,
    PanelComponent,
    NavbarComponent,
    FooterComponent,
    DefaultPageComponent,
    MainComponent,
    SidebarComponent,
    IconStatusComponent,
    SafeHtmlPipe,
    EllipsisPipe,
    NavigationButtonComponent,
    InputMaskDirective,
    ErrorContainerComponent,
    DashboardContainerComponent,
    BlockTemplateComponent
  ],
  entryComponents: [ BlockTemplateComponent ],
  providers: [
    AuthenticatedGuard,
    NewRegisterUserGuard,
    MfaLoginGuard,
    AuthStateGuard,
    JwtHelperService,
    LoggingService,
    WindowRefService,
    PopNotificationService,
    PortalInfoService,
    VersionCheckerService,
    FormlyManipulation,
    DashboardService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts